import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/**
 * Formats a decimal hours value into a human-readable Italian string.
 * e.g. 3.5 → "3 ore e 30 min", 3 → "3 ore", 0.5 → "30 min"
 */
export function formatPermitHours(hours: number): string {
  const h = Math.floor(hours);
  const hasHalf = hours % 1 !== 0;
  if (h === 0) return "30 min";
  if (!hasHalf) return `${h} ${h === 1 ? "ora" : "ore"}`;
  return `${h} ${h === 1 ? "ora" : "ore"} e 30 min.`;
}
